import { createContext } from "react";

const SideMenuCommonFilter = createContext({});

export default SideMenuCommonFilter;
